<div class="container my-5">
  <div class="row justify-content-center">
    <div class="col-md-12">
      <div class="card shadow">
        <div class="card-header bg-danger text-white">
          <h3 class="card-title text-center">Disclaimer Policy</h3>
        </div>
        <div class="card-body">
          <!-- Introduction Section -->
          <section class="mb-5">
            <h4 class="text-danger mb-4">Introduction</h4>
            <p>
              The information contained in this website is for general information purposes only. The information is provided by <strong>New Spice Solutions Private Limited</strong> and while we endeavor to keep the information up to date and correct, we make no representations or warranties of any kind, express or implied, about the completeness, accuracy, reliability, suitability, or availability with respect to the website or the information, products, services, or related graphics contained on the website for any purpose.
            </p>
            <p>
              Any reliance you place on such information is therefore strictly at your own risk.
            </p>
          </section>

          <!-- Disclaimer Policy Section -->
          <section class="mb-5">
            <h4 class="text-danger mb-4">Disclaimer Policy</h4>
            <ul>
              <li class="mb-3">
                <strong>No Liability:</strong> In no event will we be liable for any loss or damage including without limitation, indirect or consequential loss or damage, or any loss or damage whatsoever arising from loss of data or profits arising out of, or in connection with, the use of this website.
              </li>
              <li class="mb-3">
                <strong>Third-Party Links:</strong> Through this website, you are able to link to other websites which are not under the control of New Spice Solutions Private Limited. We have no control over the nature, content, and availability of those sites. The inclusion of any links does not necessarily imply a recommendation or endorse the views expressed within them.
              </li>
              <li class="mb-3">
                <strong>Website Availability:</strong> Every effort is made to keep the website up and running smoothly. However, New Spice Solutions Private Limited takes no responsibility for, and will not be liable for, the website being temporarily unavailable due to technical issues beyond our control.
              </li>
            </ul>
          </section>

          <!-- Contact Information Section -->
          <section class="mb-5">
            <h4 class="text-danger mb-4">Contact Information</h4>
            <p>
              For further assistance, please contact us at:
            </p>
            <ul>
              <li>
                <strong>Company Name:</strong> New Spice Solutions Private Limited
              </li>
              <li>
                <strong>Address:</strong>  Priska Tower, 2nd Floor, C-56/45, C Block,Industrial Area Phase 2 Sector 62, Noida - 201309 (UP)
              </li>
              <li>
                <strong>Telephone Number:</strong> <a href="tel:18002700273" class="text-decoration-none">1800 270 0273</a>
              </li>
              <li>
                <strong>E-Mail ID:</strong> <a href="mailto:care@smartdukaan.com" class="text-decoration-none">{{'care@smartdukaan.com'}}</a>
              </li>
              <li>
                <strong>Website:</strong> <a href="http://www.smartdukaan.com" target="_blank" class="text-decoration-none">www.smartdukaan.com</a>
              </li>
            </ul>
          </section>
        </div>
      </div>
    </div>
  </div>
</div>
